import styled from 'styled-components'

interface ITaxInclusiveCheckboxStyledProps {}

export const TaxInclusiveCheckboxStyled = styled.div<ITaxInclusiveCheckboxStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  user-select: none;
`
